import { Component, Input, OnInit } from "@angular/core";
import { QuestionEntity } from "src/app/models/new-product/base/question-entity.model";
import { ProposalConst } from "src/app/models/new-product/sme/mortgage-fire/singapore/base/mf-sg-proposal-constant";

@Component({
    selector: "numeric-box-question",
    templateUrl: "./numeric-box-question.component.html",
    styleUrls: ["./numeric-box-question.component.scss"],
    standalone: false
})
export class NumericBoxQuestionComponent implements OnInit {
  noAnswerDefaultText = ProposalConst.noAnswerDefaultText;
  @Input() public question!: QuestionEntity;
  @Input() public tooltipText!: string;
  constructor() {}

  ngOnInit(): void {}

  //https://stackoverflow.com/questions/40341648/angular-2-how-to-bind-input-to-model-property-with-getter-and-setter-methods
  // Getter method
  public get QuestionAnswerFormatted(): any {
    if (this.question.isAnswered() && this.question.answer != "null") {
      return Number(this.question.answer);
    } else {
      return "";
    }
  }

  // Setter method
  public set QuestionAnswerFormatted(val: number) {
    this.question.answer = String(val);
  }
}
